module.exports = __webpack_public_path__ + "static/img/09.6fff9d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/medical/09.png
// module id = FX9t
// module chunks = 1